'use strict';

/**
 *
 * @name: MODULE 'nownessApp.analytics' RUN
 *
 */

function AnalyticsRun($rootScope, $timeout) {

  'ngInject';

  $rootScope.analyticsFirstTime = true;

  $timeout(function() {

    $rootScope.analyticsFirstTime = false;
  }, 888);
}

export default AnalyticsRun;



// WEBPACK FOOTER //
// ./app/components/nn-analytics/nn-analytics.run.js